import { createServerFn } from "@tanstack/react-start";
import {
  getRequest,
  setResponseHeader,
  setResponseStatus,
} from "@tanstack/react-start/server";
import { eq } from "drizzle-orm";
import { createAuthInstance } from "~/lib/auth/auth";
import { getDb } from "~/lib/db";
import { account, user } from "~/lib/db/schema";
import { checkRateLimit, rateLimitHeaders } from "~/lib/rate-limit";

export const $getUser = createServerFn({ method: "GET" }).handler(async () => {
  const session = await createAuthInstance().api.getSession({
    headers: getRequest().headers,
    returnHeaders: true,
  });

  const cookies = session.headers?.getSetCookie();
  if (cookies?.length) {
    setResponseHeader("Set-Cookie", cookies);
  }

  return session.response?.user || null;
});

export const $checkPasswordResetEligibility = createServerFn({ method: "POST" })
  .inputValidator((input: { email: string }) => input)
  .handler(async ({ data }) => {
    const request = getRequest();
    const rateLimitResult = await checkRateLimit(request, "forgotPassword");

    const headers = rateLimitHeaders(rateLimitResult);
    for (const [key, value] of Object.entries(headers)) {
      setResponseHeader(key, value);
    }

    if (!rateLimitResult.allowed) {
      setResponseStatus(429);
      throw new Error("Too many password reset requests. Please try again later.");
    }

    const db = getDb();

    const accounts = await db
      .select({
        providerId: account.providerId,
        password: account.password,
        userEmail: user.email,
      })
      .from(account)
      .innerJoin(user, eq(account.userId, user.id))
      .where(eq(user.email, data.email.toLowerCase()));

    if (accounts.length === 0) {
      return { eligible: true, reason: "none" };
    }

    const hasPassword = accounts.some((acc) => acc.password != null);
    if (!hasPassword) {
      const providers = accounts
        .filter((acc) => acc.providerId !== "email")
        .map((acc) => acc.providerId);
      return { eligible: false, reason: "social", providers };
    }

    return { eligible: true, reason: "none" };
  });
